webpackJsonp([0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _angularUiBootstrap = __webpack_require__(4);
	
	var _angularUiBootstrap2 = _interopRequireDefault(_angularUiBootstrap);
	
	var _angularTranslate = __webpack_require__(6);
	
	var _angularTranslate2 = _interopRequireDefault(_angularTranslate);
	
	var _angularTranslateLoaderStaticFiles = __webpack_require__(7);
	
	var _angularTranslateLoaderStaticFiles2 = _interopRequireDefault(_angularTranslateLoaderStaticFiles);
	
	var _commonCommon = __webpack_require__(8);
	
	var _commonCommon2 = _interopRequireDefault(_commonCommon);
	
	var _componentsComponents = __webpack_require__(182);
	
	var _componentsComponents2 = _interopRequireDefault(_componentsComponents);
	
	var _appComponent = __webpack_require__(196);
	
	var _appComponent2 = _interopRequireDefault(_appComponent);
	
	var _angularResource = __webpack_require__(32);
	
	var _angularResource2 = _interopRequireDefault(_angularResource);
	
	var _chapsOffClickLoader = __webpack_require__(213);
	
	var _chapsOffClickLoader2 = _interopRequireDefault(_chapsOffClickLoader);
	
	_angular2['default'].module('app', [_angularUiRouter2['default'], _angularUiBootstrap2['default'], _angularTranslate2['default'], _angularTranslateLoaderStaticFiles2['default'], _commonCommon2['default'], _componentsComponents2['default'], _angularResource2['default'], _chapsOffClickLoader2['default']]).constant("LANGUAGES", ['es-ES', 'en-GB']).config(["$locationProvider", "$translateProvider", "$urlRouterProvider", function ($locationProvider, $translateProvider, $urlRouterProvider) {
	  "ngInject";
	  // @see: https://github.com/angular-ui/ui-router/wiki/Frequently-Asked-Questions
	  // #how-to-configure-your-server-to-work-with-html5mode
	  $locationProvider.html5Mode(true).hashPrefix('!');
	
	  $urlRouterProvider.otherwise('/home');
	
	  $translateProvider.useStaticFilesLoader({
	    prefix: 'app/assets/translations/locale-',
	    suffix: '.json'
	  });
	
	  $translateProvider.fallbackLanguage('en-GB');
	  $translateProvider.use('en-GB');
	  $translateProvider.useSanitizeValueStrategy(null);
	}])
	// Patch related with: https://github.com/oauthjs/angular-oauth2/issues/32
	.config(["$httpProvider", function ($httpProvider) {
	  'ngInject';
	
	  function authInterceptor($q, $rootScope) {
	    return {
	      responseError: function responseError(rejection) {
	        if (401 === rejection.status && rejection.data && 'invalid_grant' === rejection.data.error) {
	          $rootScope.$emit('oauth:error', rejection);
	        }
	        return $q.reject(rejection);
	      }
	    };
	  }
	
	  authInterceptor.$inject = ['$q', '$rootScope'];
	
	  $httpProvider.interceptors.push(authInterceptor);
	}]).run(["$state", function ($state) {
	  "ngInject";
	  //TODO Review run state on page load
	  $state.go('home');
	}]).component('app', _appComponent2['default']);

/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _navbarNavbar = __webpack_require__(9);
	
	var _navbarNavbar2 = _interopRequireDefault(_navbarNavbar);
	
	var _footerFooter = __webpack_require__(18);
	
	var _footerFooter2 = _interopRequireDefault(_footerFooter);
	
	var _userUser = __webpack_require__(22);
	
	var _userUser2 = _interopRequireDefault(_userUser);
	
	var _transfersTableTransfersTable = __webpack_require__(24);
	
	var _transfersTableTransfersTable2 = _interopRequireDefault(_transfersTableTransfersTable);
	
	var _languageSelectorLanguageSelector = __webpack_require__(13);
	
	var _languageSelectorLanguageSelector2 = _interopRequireDefault(_languageSelectorLanguageSelector);
	
	var _stSelectStSelect = __webpack_require__(156);
	
	var _stSelectStSelect2 = _interopRequireDefault(_stSelectStSelect);
	
	var _stSelectFilterStSelectFilter = __webpack_require__(160);
	
	var _stSelectFilterStSelectFilter2 = _interopRequireDefault(_stSelectFilterStSelectFilter);
	
	var _authAuth = __webpack_require__(164);
	
	var _authAuth2 = _interopRequireDefault(_authAuth);
	
	var _loaderLoader = __webpack_require__(178);
	
	var _loaderLoader2 = _interopRequireDefault(_loaderLoader);
	
	var commonModule = _angular2['default'].module('app.common', [_navbarNavbar2['default'], _userUser2['default'], _footerFooter2['default'], _languageSelectorLanguageSelector2['default'], _transfersTableTransfersTable2['default'], _stSelectStSelect2['default'], _stSelectFilterStSelectFilter2['default'], _authAuth2['default'], _loaderLoader2['default']]).name;
	
	exports['default'] = commonModule;
	module.exports = exports['default'];

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _navbarComponent = __webpack_require__(10);
	
	var _navbarComponent2 = _interopRequireDefault(_navbarComponent);
	
	var _languageSelectorLanguageSelector = __webpack_require__(13);
	
	var _languageSelectorLanguageSelector2 = _interopRequireDefault(_languageSelectorLanguageSelector);
	
	var _servicesSharedService = __webpack_require__(17);
	
	var _servicesSharedService2 = _interopRequireDefault(_servicesSharedService);
	
	var navbarModule = _angular2['default'].module('navbar', [_angularUiRouter2['default'], _languageSelectorLanguageSelector2['default'], _servicesSharedService2['default']]).component('navbar', _navbarComponent2['default']).name;
	
	exports['default'] = navbarModule;
	module.exports = exports['default'];

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _navbarHtml = __webpack_require__(11);
	
	var _navbarHtml2 = _interopRequireDefault(_navbarHtml);
	
	var _navbarController = __webpack_require__(12);
	
	var _navbarController2 = _interopRequireDefault(_navbarController);
	
	var navbarComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _navbarHtml2['default'],
	  controller: _navbarController2['default'],
	  controllerAs: 'vm'
	};
	
	exports['default'] = navbarComponent;
	module.exports = exports['default'];

/***/ },
/* 11 */
/***/ function(module, exports) {

	module.exports = "<!-- Fixed navbar -->\n<nav class=\"navbar navbar-default navbar-fixed-top\">\n    <div class=\"st-nav-container-fluid\">\n        <div class=\"navbar-header\">\n            <button type=\"button\" class=\"navbar-toggle\" ng-click=\"vm.isCollapsed = !vm.isCollapsed\">\n                <span class=\"sr-only\">Toggle navigation</span>\n                <span class=\"icon-bar\"></span>\n                <span class=\"icon-bar\"></span>\n                <span class=\"icon-bar\"></span>\n            </button>\n            <a class=\"navbar-brand\" href=\"\" ui-sref=\"home\"><img src=\"app/assets/images/st-logo.svg\" alt=\"Suntransfers\"/></a>\n        </div>\n        <div id=\"navbar\" class=\"navbar-collapse collapse\" ng-class=\"{'in': vm.isCollapsed}\">\n            <ul class=\"nav navbar-nav navbar-right\">\n                <!--<li ui-sref-active-eq=\"active\" ui-sref=\"home\"><a href>{{ 'NAVBAR.HOME' | translate }}</a></li>-->\n                <li ng-click=\"vm.logout()\" ng-if=\"vm.authService.authenticated\">\n                    <a href ng-click=\"vm.isCollapsed = !vm.isCollapsed\">{{ 'button_logout' | translate }}</a></li>\n                <st-lang-selector></st-lang-selector>\n            </ul>\n        </div>\n        <!--/.nav-collapse -->\n    </div>\n    <div class=\"navbar-border\" ng-if=\"!vm.loader.visible\"></div>\n    <loader ng-if=\"vm.loader.visible\"></loader>\n</nav>\n"

/***/ },
/* 12 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var NavbarController = (function () {
	    NavbarController.$inject = ["$state", "authService", "sharedService"];
	    function NavbarController($state, authService, sharedService) {
	        'ngInject';
	
	        _classCallCheck(this, NavbarController);
	
	        this.$state = $state;
	        this.authService = authService;
	        this.loader = sharedService.loader;
	        this.name = 'navbar';
	    }
	
	    _createClass(NavbarController, [{
	        key: 'logout',
	        value: function logout() {
	            var _this = this;
	
	            this.authService.logout().then(function () {
	                _this.$state.go('auth.login');
	            });
	        }
	    }]);
	
	    return NavbarController;
	})();
	
	exports['default'] = NavbarController;
	module.exports = exports['default'];

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _languageSelectorDirective = __webpack_require__(14);
	
	var _languageSelectorDirective2 = _interopRequireDefault(_languageSelectorDirective);
	
	var languageSelectorModule = _angular2['default'].module('languageSelector', [_angularUiRouter2['default']]).directive('stLangSelector', _languageSelectorDirective2['default']).name;
	
	exports['default'] = languageSelectorModule;
	module.exports = exports['default'];

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _languageSelectorHtml = __webpack_require__(15);
	
	var _languageSelectorHtml2 = _interopRequireDefault(_languageSelectorHtml);
	
	var _languageSelectorController = __webpack_require__(16);
	
	var _languageSelectorController2 = _interopRequireDefault(_languageSelectorController);
	
	function languageSelectorDirective() {
	  return {
	    restrict: 'AEC',
	    replace: true,
	    scope: {},
	    template: _languageSelectorHtml2['default'],
	    controller: _languageSelectorController2['default'],
	    controllerAs: 'vm',
	    link: function link(scope) {
	      scope.name = 'Foo';
	    }
	  };
	}
	exports['default'] = languageSelectorDirective;
	module.exports = exports['default'];

/***/ },
/* 15 */
/***/ function(module, exports) {

	module.exports = "<li  uib-dropdown on-toggle=\"vm.toggled(open)\">\n  <a href=\"\" class=\"dropdown-toggle\" uib-dropdown-toggle>\n    {{vm.languageLabelInstant}}<span class=\"st-icon-chevron-down  st-icon-chevron-down-sm-button\"></span>\n  </a>\n  <ul class=\"dropdown-menu\" uib-dropdown-menu aria-labelledby=\"simple-dropdown\">\n      <li ng-repeat=\"lang in vm.languages\">\n          <a href ng-click=\"vm.fetchLanguage(lang)\"> {{lang | translate}} </a>\n      </li>\n  </ul>\n</li>\n"

/***/ },
/* 16 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var LanguageSelectorController = (function () {
	
	  // TODO: CONSTANTS
	  // static const SUFIX = '-label';
	
	  LanguageSelectorController.$inject = ["$translate", "$state", "LANGUAGES"];
	  function LanguageSelectorController($translate, $state, LANGUAGES) {
	    'ngInject';
	
	    _classCallCheck(this, LanguageSelectorController);
	
	    this.name = 'languageSelector';
	    this.$translate = $translate;
	    this.languages = LANGUAGES;
	    this.$state = $state;
	    var currentLanguage = $translate.proposedLanguage();
	    $translate.onReady().then(this.setLanguage.bind(this, currentLanguage));
	  }
	
	  _createClass(LanguageSelectorController, [{
	    key: 'fetchLanguage',
	    value: function fetchLanguage(lang) {
	      this.$translate.use(lang).then(this.setLanguage.bind(this, lang));
	    }
	  }, {
	    key: 'setLanguage',
	    value: function setLanguage(lang) {
	      this.language = lang;
	      this.languageLabel = this.language + '-label';
	      this.languageLabelInstant = this.$translate.instant(this.languageLabel);
	      this.$state.reload('home');
	    }
	  }, {
	    key: 'toggleDropdown',
	    value: function toggleDropdown($event) {
	      $event.preventDefault();
	      $event.stopPropagation();
	      this.status.isopen = !this.status.isopen;
	    }
	  }]);
	
	  return LanguageSelectorController;
	})();
	
	exports['default'] = LanguageSelectorController;
	module.exports = exports['default'];

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var SharedService = function SharedService() {
	    'ngInject';
	
	    _classCallCheck(this, SharedService);
	
	    this.refreshingToken = false;
	    this.loader = {
	        visible: false
	    };
	};
	
	var sharedServiceModule = _angular2['default'].module('st.services.shared', []).service('sharedService', SharedService).name;
	
	exports['default'] = sharedServiceModule;
	module.exports = exports['default'];

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _footerComponent = __webpack_require__(19);
	
	var _footerComponent2 = _interopRequireDefault(_footerComponent);
	
	var footerModule = _angular2['default'].module('footer', [_angularUiRouter2['default']]).component('footer', _footerComponent2['default']).name;
	
	exports['default'] = footerModule;
	module.exports = exports['default'];

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _footerHtml = __webpack_require__(20);
	
	var _footerHtml2 = _interopRequireDefault(_footerHtml);
	
	var _footerController = __webpack_require__(21);
	
	var _footerController2 = _interopRequireDefault(_footerController);
	
	var footerComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _footerHtml2['default'],
	  controller: _footerController2['default'],
	  controllerAs: 'vm'
	};
	
	exports['default'] = footerComponent;
	module.exports = exports['default'];

/***/ },
/* 20 */
/***/ function(module, exports) {

	module.exports = "<div class=\"o-footer__text\">\n    {{'copy_right' | translate:vm.values}} | {{'right_reserved' | translate}} | <a href=\"\">{{'terms_conditions' | translate}}</a>\n</div>\n"

/***/ },
/* 21 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var FooterController = function FooterController() {
	  _classCallCheck(this, FooterController);
	
	  this.name = 'footer';
	  this.values = {
	    current_year: new Date().getFullYear()
	  };
	};
	
	exports['default'] = FooterController;
	module.exports = exports['default'];

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _userFactory = __webpack_require__(23);
	
	var _userFactory2 = _interopRequireDefault(_userFactory);
	
	var userModule = _angular2['default'].module('user', []).factory('User', _userFactory2['default']).name;
	
	exports['default'] = userModule;
	module.exports = exports['default'];

/***/ },
/* 23 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var UserFactory = function UserFactory() {
	  var user = {};
	
	  var getUser = function getUser() {
	    return user;
	  };
	
	  var isSignedIn = function isSignedIn() {
	    return user.isSignedIn;
	  };
	
	  return { getUser: getUser, isSignedIn: isSignedIn };
	};
	
	exports["default"] = UserFactory;
	module.exports = exports["default"];

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _transfersTableComponent = __webpack_require__(25);
	
	var _transfersTableComponent2 = _interopRequireDefault(_transfersTableComponent);
	
	var _transfersTableService = __webpack_require__(28);
	
	var _transfersTableService2 = _interopRequireDefault(_transfersTableService);
	
	var _transfersTableFilter = __webpack_require__(30);
	
	var _transfersTableFilter2 = _interopRequireDefault(_transfersTableFilter);
	
	var _apiTransfersService = __webpack_require__(31);
	
	var _apiTransfersService2 = _interopRequireDefault(_apiTransfersService);
	
	var _servicesSharedService = __webpack_require__(17);
	
	var _servicesSharedService2 = _interopRequireDefault(_servicesSharedService);
	
	var _servicesCacheService = __webpack_require__(34);
	
	var _servicesCacheService2 = _interopRequireDefault(_servicesCacheService);
	
	var _moment = __webpack_require__(35);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var transfersTableModule = _angular2['default'].module('transfersTable', [_angularUiRouter2['default'], _servicesSharedService2['default'], _servicesCacheService2['default'], _apiTransfersService2['default']]).constant('moment', _moment2['default']).component('transfersTable', _transfersTableComponent2['default']).service('transfersTableService', _transfersTableService2['default']).filter('transfersTableFilter', _transfersTableFilter2['default']).name;
	
	exports['default'] = transfersTableModule;
	module.exports = exports['default'];

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _transfersTableHtml = __webpack_require__(26);
	
	var _transfersTableHtml2 = _interopRequireDefault(_transfersTableHtml);
	
	var _transfersTableController = __webpack_require__(27);
	
	var _transfersTableController2 = _interopRequireDefault(_transfersTableController);
	
	var transfersTableComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _transfersTableHtml2['default'],
	  controller: _transfersTableController2['default']
	};
	
	exports['default'] = transfersTableComponent;
	module.exports = exports['default'];

/***/ },
/* 26 */
/***/ function(module, exports) {

	module.exports = "<!-- TODO:\n- Create static components for cleaner html?\n- Move dropdowns to home component for page atomic layout\n-->\n<style>\n  .file-upload-container {\n    display: inline;\n    flex-direction: column;\n    gap: 10px;\n    align-items: start;\n    margin-top: 4%;\n    margin-left: 5%;\n  }\n\n  .styled-file-input {\n    max-width: 250px;\n    padding: 8px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    margin-top: 10%;\n    height: 38px;\n  }\n\n  .d-flex {\n    display: flex;\n    align-items: center;\n    gap: 15px;\n  }\n\n  .table-bottom {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  .popup-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n  }\n\n  .popup-box {\n    width: 400px;\n    padding: 20px;\n    border-radius: 8px;\n    text-align: center;\n    position: relative;\n    font-size: 16px;\n    font-weight: bold;\n  }\n\n  .success-popup {\n    background: #d4edda;\n    color: #155724;\n    border: 1px solid #c3e6cb;\n  }\n\n  .error-popup {\n    background: #f8d7da;\n    color: #721c24;\n    border: 1px solid #f5c6cb;\n  }\n\n  .warning-popup {\n    background-color: #ffda47;\n    color: black;\n    border: 1px solid #f5c6cb;\n  }\n\n  .close-btn {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    border: none;\n    background: none;\n    font-size: 18px;\n    cursor: pointer;\n  }\n\n  .shuttle-transfers-container {\n    display: inline-block;\n    border: 1px solid #ccc;\n    padding: 15px;\n    border-radius: 8px;\n    background-color: #f9f9f9;\n    width: 38%;\n  }\n\n  .actions-container {\n    display: ruby-text;\n    gap: 10px;\n    align-items: center;\n  }\n\n  #upload-button:disabled {\n    background-color: #ccc;\n  }\n\n  .file-upload-container::before {\n    content: \"\";\n    display: inline-block;\n    width: 3px;\n    height: 18px;\n    background-color: black;\n    margin-right: 20px;\n  }\n\n</style>\n<div class=\"{{ $ctrl.name }}\">\n    <h2 class=\"heading text-center\">{{'shuttle_title' | translate}}</h2>\n\n    <div class=\"table-filters clearfix\">\n        <st-select-filter class=\"dropdown pull-left\" items=\"$ctrl.leftFilterItems\" filter=\"$ctrl.leftFilterName\" change-filter=\"$ctrl.handleFilterChange(selectedItem)\"></st-select-filter>\n        <!-- TODO: CSS dropdown li width, remove ng-if hack for resolve -->\n        <st-select class=\"dropdown pull-right\" ng-if=\"$ctrl.gateways.length\" items=\"$ctrl.gateways\" selected-item=\"$ctrl.selectedGateway\" get-transfers=\"$ctrl.handleGatewayChange(gateway)\"></st-select>\n    </div>\n\n    <div class=\"spinner-centered\" ng-if=\"$ctrl.loader.visible\">\n        <div class=\"spinner\"></div>\n    </div>\n    <div class=\"no-more-tables\" ng-if=\"!$ctrl.loader.visible\">\n        <table class=\"transferstable__group\">\n            <thead>\n            <tr class=\"transferstable__row\">\n                <th class=\"transferstable__item--transfer-reference\"><div uib-tooltip=\"{{ 'sub_transfer_reference' | translate }}\" class=\"tooltip__item\" tooltip-class=\"st-tooltip\" tooltip-popup-delay=\"500\">{{ 'sub_transfer_reference' | translate }}</div></th>\n                <th class=\"transferstable__item--lead-passenger\"><div uib-tooltip=\"{{ 'sub_lead_passenger' | translate }}\" class=\"tooltip__item\" tooltip-class=\"st-tooltip\" tooltip-popup-delay=\"500\">{{'sub_lead_passenger' | translate}}</div></th>\n                <th class=\"transferstable__item--pickup-location\"><div uib-tooltip=\"{{ 'sub_pickup_location' | translate }}\" class=\"tooltip__item\" tooltip-class=\"st-tooltip\" tooltip-popup-delay=\"500\">{{'sub_pickup_location' | translate}}</div></th>\n                <th class=\"transferstable__item--hotel\"><div uib-tooltip=\"{{ 'sub_hotel' | translate }}\" class=\"tooltip__item\" tooltip-class=\"st-tooltip\" tooltip-popup-delay=\"500\">{{'sub_hotel' | translate}}</div></th>\n                <th class=\"transferstable__item--pickup-point\"><div uib-tooltip=\"{{ 'pickup_point' | translate }}\" class=\"tooltip__item\" tooltip-class=\"st-tooltip\" tooltip-popup-delay=\"500\">{{'pickup_point' | translate}}</div></th>\n                <th class=\"transferstable__item--flight-number\"><div uib-tooltip=\"{{ 'sub_flight_number' | translate }}\" class=\"tooltip__item\" tooltip-class=\"st-tooltip\" tooltip-popup-delay=\"500\">{{'sub_flight_number' | translate}}</div></th>\n                <th class=\"transferstable__item--flight-time\"><div uib-tooltip=\"{{ 'sub_flight_time' | translate }}\" class=\"tooltip__item\" tooltip-class=\"st-tooltip\" tooltip-popup-delay=\"500\">{{'sub_flight_time' | translate}}</div></th>\n                <th class=\"transferstable__item--pickup-time\"><div uib-tooltip=\"{{ 'sub_pickup_time' | translate }}\" class=\"tooltip__item\" tooltip-class=\"st-tooltip\" tooltip-popup-delay=\"500\">{{'sub_pickup_time' | translate}}</div></th>\n            </tr>\n            </thead>\n            <tbody>\n            <tr class=\"transferstable__row\" ng-repeat=\"item in $ctrl.transfers | filter : $ctrl.leftFilterName\">\n                <td class=\"transferstable__item--transfer-reference\" data-title=\"{{ 'sub_transfer_reference' | translate }}\" alt=\"{{::item.transferReference}}\">\n                    <span class=\"label label-{{::$ctrl.labelTypes[item.labelType]}} label-lg label-block\">\n                      {{::item.transferReference}}\n                    </span>\n                </td>\n                <td class=\"transferstable__item--lead-passenger\" data-title=\"{{ 'sub_lead_passenger' | translate }}\" alt=\"{{::item.leadPassenger}}\"><div uib-tooltip=\"{{::item.leadPassenger}}\" class=\"tooltip__item\" tooltip-class=\"st-tooltip\" tooltip-popup-delay=\"500\">{{::item.leadPassenger}}</div></td>\n                <td class=\"transferstable__item--pickup-location\" data-title=\"{{ 'sub_pickup_location' | translate }}\" alt=\"{{::item.pickupLocation}}\"><div uib-tooltip=\"{{::item.pickupLocation}}\" class=\"tooltip__item\" tooltip-class=\"st-tooltip\" tooltip-popup-delay=\"500\">{{::item.pickupLocation}}</div></td>\n                <td class=\"transferstable__item--hotel\" data-title=\"{{ 'sub_hotel' | translate }}\" alt=\"{{::item.pickupHotel}}\"><div uib-tooltip=\"{{::item.pickupHotel}}\" class=\"tooltip__item\" tooltip-class=\"st-tooltip\" tooltip-popup-delay=\"500\">{{::item.pickupHotel}}</div></td>\n                <td class=\"transferstable__item--pickup-point\" data-title=\"{{ 'pickup_point' | translate }}\" alt=\"{{::item.pickupPoint}}\">\n                  <div ng-if=\"item.transfersTable.pickupPointSaved\" uib-tooltip=\"{{item.pickupPoint}}\"\n                       class=\"tooltip__item\" tooltip-class=\"st-tooltip\" tooltip-popup-delay=\"500\">{{item.pickupPoint}}\n                  </div>\n\n                  <div class=\"input-group\" ng-if=\"!item.transfersTable.pickupPointSaved\"\n                       ng-click=\"$ctrl.togglePickupPointEdit(item, $event)\">\n                    <div class=\"spinner-centered\" ng-if=\"item.transfersTable.saving\">\n                      <div class=\"spinner\"></div>\n                    </div>\n                    <input type=\"text\" class=\"form-control\"\n                           ng-model=\"item.pickupPoint\">\n                    <span class=\"input-group-addon\">\n                         <i class=\"st-icon-map-marker st-font-xl st-font-color-gray\"></i>\n                        </span>\n                  </div>\n                  <div class=\"dropdown-container\" ng-if=\"item.transfersTable.dropdownPickupPointIsOpen\"\n                       off-click=\"$ctrl.toggleDropdownOffClick(item)\"\n                       off-click-if=\"item.transfersTable.dropdownPickupPointIsOpen\">\n                    <textarea class=\"form-control\"\n                              ng-model=\"item.transfersTable.tempPickupPoint\"\n                              placeholder=\"Enter new pickup point\"></textarea>\n\n                    <button type=\"button\" class=\"btn-st btn-st-success btn-block btn-lg\"\n                            ng-click=\"$ctrl.savePickupPoint(item, $event)\">{{'button_save' | translate}}\n                    </button>\n                  </div>\n                </td>\n                <td class=\"transferstable__item--flight-number\" data-title=\"{{ 'sub_flight_number' | translate }}\" alt=\"{{item.flightNumber}}\"><div uib-tooltip=\"{{item.flightNumber}}\" class=\"tooltip__item\" tooltip-class=\"st-tooltip\" tooltip-popup-delay=\"500\">{{item.flightNumber}}</div></td>\n                <td class=\"transferstable__item--flight-time\" data-title=\"{{ 'sub_flight_time' | translate }}\" alt=\"{{item.transfersTable.flightTimeDateConcat}}\"><div uib-tooltip=\"{{item.transfersTable.flightTimeDateConcat}}\" class=\"tooltip__item\" tooltip-class=\"st-tooltip\" tooltip-popup-delay=\"500\">{{item.transfersTable.flightTimeDateConcat}}</div></td>\n                <td class=\"transferstable__item--pickup-time\" data-title=\"{{ 'sub_pickup_time' | translate }}\" alt=\"{{item.transfersTable.pickupTimeDateConcat}}\">\n\n                    <div ng-if=\"item.transfersTable.pickupTimeSaved\" uib-tooltip=\"{{item.transfersTable.pickupTimeDateConcat}}\" class=\"tooltip__item\" tooltip-class=\"st-tooltip\" tooltip-popup-delay=\"500\">{{item.transfersTable.pickupTimeDateConcat}}</div>\n\n                    <!-- DROPDOWN -->\n                    <div uib-dropdown ng-if=\"!item.transfersTable.pickupTimeSaved\" auto-close=\"disabled\" is-open=\"item.transfersTable.dropdownIsOpen\" off-click=\"$ctrl.toggleDropdownOffClick(item)\" off-click-if=\"item.transfersTable.dropdownIsOpen\">\n                        <div class=\"input-group \" ng-click=\"$ctrl.togglePickupTimeDropdown($event, item)\">\n                            <!-- TODO Create spinner component -->\n                            <div class=\"spinner-centered\" ng-if=\"item.transfersTable.saving\">\n                                <div class=\"spinner\"></div>\n                            </div>\n                            <!-- TODO: move condition to controller -->\n                            <input type=\"text\" class=\"form-control date-input\" ng-if=\"item.pickupTime\" ng-model=\"item.transfersTable.pickupTimeDateConcat\" disable=\"disabled\">\n                            <input type=\"text\" class=\"form-control date-input\" ng-if=\"!item.pickupTime\" disabled=\"disabled\">\n\n                            <span class=\"input-group-addon\">\n                              <i class=\"st-icon-calendar st-font-xl st-font-color-gray\"></i>\n                            </span>\n                        </div>\n                        <ul class=\"dropdown-menu dropdown-datepicker\" uib-dropdown-menu>\n                            <!-- EDIT FIELD -->\n\n                            <li class=\"dropdown-edit-date\" ng-if=\"!item.transfersTable.datePicker.options.isOpen && item.labelType > 0\">\n                                <div class=\"pull-left\">\n                                    <!-- TODO: movefilter out of tamplate? scope | filter: 'separator':index -->\n                                    {{item.transfersTable.datePicker.options.dateModel | transfersTableFilter}}\n                                </div>\n                                <div class=\"pull-right text-right\">\n                                    <a href=\"#\" ng-click=\"$ctrl.toggleDatePicker(item, $event)\">{{'button_edit' | translate}}</a>\n                                </div>\n                            </li>\n\n                            <!-- Date picker -->\n                            <li ng-if=\"item.transfersTable.datePicker.options.isOpen\" class=\"dropdown-date-picker\">\n                                <div>\n                                    <div class=\"text-center\"><strong>{{item.transfersTable.datePicker.options.dateModel | transfersTableFilter}}</strong></div>\n\n                                    <uib-datepicker\n                                            ng-change=\"$ctrl.datepickerOnChange(item)\"\n                                            ng-model=\"item.transfersTable.datePicker.options.dateModel\"\n                                            datepicker-options=\"::item.transfersTable.datePicker.options\"\n                                            class=\"st-datepicker\">\n                                    </uib-datepicker>\n                                </div>\n                            </li>\n                            <!-- END Date picker -->\n                            <!-- Time picker -->\n\n                            <li class=\"dropdown-timepicker\">\n                                <div class=\"pull-left\">\n                                    {{'select_time' | translate}}\n                                </div>\n                                <div class=\"pull-right text-right\">\n                                    <p>{{item.PickupTimeLocaleTimeString}}</p>\n\n\n                                    <!-- HotFix remove max if date != maxdate -->\n                                    <uib-timepicker\n                                            class=\"uib-timepicker\"\n                                            min=\"item.transfersTable.timePicker.min\"\n                                            max=\"item.transfersTable.timePicker.max\"\n                                            ng-model=\"item.transfersTable.timePicker.model\"\n                                            hour-step=\"1\"\n                                            minute-step=\"5\"\n                                            show-meridian=\"ismeridian\">\n                                    </uib-timepicker>\n                                </div>\n                            </li>\n                            <li style=\"font-weight: bold; text-align: center; font-size: 13px;\">\n                               {{'latest_pickup_time' | translate}}: {{item.transfersTable.latestPickupTimeDateConcat}}\n                            </li>\n                            <li style=\"font-weight: bold; text-align: center; font-size: 13px;\">\n                                {{'earliest_pickup_time' | translate}}: {{item.transfersTable.earliestPickupTimeDateConcat}}\n                            </li>\n                            <!-- END Time picker -->\n                            <li ng-if=\"!$ctrl.isPickupTimeValid(item)\">\n                                <uib-alert type=\"danger\">{{ $ctrl.exceededPickupTimeErrorText }}</uib-alert>\n                            </li>\n                            <li ng-if=\"$ctrl.isPickupTimeValid(item)\">\n                                <button type=\"button\" class=\"btn-st btn-st-success btn-block btn-lg\" ng-click=\"$ctrl.saveFieldDate(item, $event)\">{{'button_save' | translate}}</button>\n                                </button>\n                            </li>\n                        </ul>\n                    </div>\n                    <!-- END DROPDOWN -->\n                </td>\n            </tr>\n            </tbody>\n        </table>\n        <div class=\"o-transfers-table__menu\" ng-if=\"$ctrl.showMoreButton\">\n            <span class=\"o-transfers-table__text\" style=\"cursor: pointer;\" ng-click=\"$ctrl.showMoreTransfers()\">\n                {{'show_more' | translate}}\n            </span>\n        </div>\n      <div class=\"row\">\n          <div class=\"table-bottom col-md-12 d-flex justify-content-between align-items-center\">\n            <fieldset class=\"shuttle-transfers-container\">\n              <legend>Upcoming Shuttle Transfers</legend>\n              <div class=\"actions-container\">\n                <button type=\"button\" class=\"btn-st btn-st-primary btn-lg\"\n                        ng-click=\"$ctrl.downloadExcel(gateway, $ctrl.moment().add(2, 'days').format($ctrl.filterDateFormat))\">\n                  Download Excel\n                </button>\n\n                <div class=\"file-upload-container\">\n                  <input type=\"file\" id=\"fileInput\" class=\"styled-file-input\" accept=\".xlsx\"/>\n                  <button type=\"button\" id=\"upload-button\" class=\"btn-st btn-st-primary btn-lg\" ng-click=\"$ctrl.uploadExcel()\" ng-disabled=\"$ctrl.isUploading\">\n                    {{$ctrl.isUploading ? 'Uploading...' : 'Upload Excel'}}\n                  </button>\n                </div>\n              </div>\n            </fieldset>\n          <button type=\"submit\" class=\"btn-st btn-st-success bt-st-fixed btn-lg\" ng-click=\"$ctrl.saveTransfers()\">\n            {{ 'button_submit' | translate }}\n          </button>\n        </div>\n      </div>\n    </div>\n  <div ng-if=\"$ctrl.showPopup\" class=\"popup-overlay\">\n    <div class=\"popup-box\" ng-class=\"{\n        'success-popup': $ctrl.uploadSuccess && $ctrl.style === 'success',\n        'warning-popup': $ctrl.style === 'warning',\n        'error-popup': $ctrl.style === 'error'}\">\n      <button class=\"close-btn\" ng-click=\"$ctrl.closePopup()\">✖</button>\n      <p ng-bind-html=\"$ctrl.uploadMessage\"></p>\n    </div>\n  </div>\n</div>\n"

/***/ },
/* 27 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var TransfersTableController = (function () {
	  TransfersTableController.$inject = ["$sce", "$timeout", "$filter", "$translate", "transfersTableService", "sharedService", "moment"];
	  function TransfersTableController($sce, $timeout, $filter, $translate, transfersTableService, sharedService, moment) {
	    'ngInject';
	
	    //TODO: Get airport names by selected language
	    //Dependencies
	
	    _classCallCheck(this, TransfersTableController);
	
	    this.name = 'transfersTable';
	    this.transfersTableService = transfersTableService;
	    this.loader = sharedService.loader;
	    this.transfersTableFilter = $filter('transfersTableFilter');
	    this.$translate = $translate;
	    this.showMoreButton = true;
	    this.moment = moment;
	    this.$timeout = $timeout;
	    this.$sce = $sce;
	    this.isSuccess = false;
	
	    this.style = "";
	    this.isUploading = false;
	    this.uploadMessage = "";
	    this.uploadSuccess = false;
	    this.uploadFileName = "";
	    this.showPopup = false;
	
	    this.gateways = null;
	    this.leftFilterName = {};
	    this.labelTypes = {
	      0: 'danger',
	      1: 'warning',
	      2: 'default'
	    };
	    this.formatDate = 'YYYY-MM-DD HH:mm:ss';
	    this.filterDateFormat = 'YYYY-MM-DD';
	
	    // Dropdown Filter
	    // TODO: move to component
	    this.DropdownFilterText = this.$translate.instant('dropdown_all_transfers');
	    this.exceededPickupTimeErrorText = this.$translate.instant('exceeded_pickup_time_error');
	
	    // Left dropdown conf
	    this.leftFilterItems = [{
	      name: 'dropdown_all_transfers',
	      filter: ''
	    }, {
	      name: 'dropdown_transfer_no_pickup',
	      filter: {
	        pickupTime: '!'
	      }
	    }];
	
	    //Transfers
	    this.transfers = [];
	    this.getGateways(this.moment().add(2, 'days').format(this.filterDateFormat));
	  }
	
	  _createClass(TransfersTableController, [{
	    key: 'datepickerOnChange',
	    value: function datepickerOnChange(item) {
	
	      var max = this.moment(item.transfersTable.datePicker.options.maxDate);
	      var selected = this.moment(item.transfersTable.datePicker.options.dateModel);
	
	      if (selected.isSame(max, 'day')) {
	        item.transfersTable.timePicker.model = this.moment(item.transfersTable.datePicker.options.maxDate).toDate();
	      } else {
	        item.transfersTable.timePicker.model = this.moment(item.transfersTable.datePicker.options.minDate).toDate();
	      }
	    }
	  }, {
	    key: 'toggleLoader',
	    value: function toggleLoader() {
	      this.loader.visible = !this.loader.visible;
	    }
	  }, {
	    key: 'getTransfersByGateway',
	    value: function getTransfersByGateway(gatewayId, endDate) {
	      var _this = this;
	
	      //Get transfers data
	      this.toggleLoader();
	      this.transfersTableService.getTransfersByGateway(gatewayId, this.formatDate, endDate).then(function (data) {
	        data.forEach(function (item) {
	          _this.checkDates(item);
	        });
	        _this.transfers = data;
	      })['finally'](function () {
	        _this.toggleLoader();
	      });
	    }
	  }, {
	    key: 'showMoreTransfers',
	    value: function showMoreTransfers() {
	      this.showMoreButton = false;
	      this.getTransfersByGateway(this.getSelectedGatewayIds(), this.moment().add(6, 'days').format(this.filterDateFormat));
	    }
	  }, {
	    key: 'getGateways',
	    value: function getGateways(endDate) {
	      var _this2 = this;
	
	      this.toggleLoader();
	      this.transfersTableService.getGateways().then(function (data) {
	        _this2.gateways = [{ id: 'all', name: 'All Gateways' }].concat(_toConsumableArray(data.gateways));
	        _this2.gateways.gatewayIds = _this2.gateways.filter(function (gateway) {
	          return gateway.id !== 'all';
	        }).map(function (gateway) {
	          return gateway.id;
	        }).join(',');
	        if (_this2.gateways.length > 1) {
	          _this2.getTransfersByGateway(_this2.gateways.gatewayIds, endDate);
	        }
	      })['finally'](function () {
	        _this2.toggleLoader();
	      });
	    }
	  }, {
	    key: 'toogleLoaderAndSumbit',
	    value: function toogleLoaderAndSumbit(transferToUpdate) {
	      transferToUpdate.map(function (item) {
	        return item.transfersTable.saving = !item.transfersTable.saving;
	      });
	    }
	  }, {
	    key: 'saveTransfers',
	    value: function saveTransfers() {
	      var _this3 = this;
	
	      var transferToUpdate = this.transfers.filter(function (item) {
	        return (angular.isObject(item.pickupTime) || item.transfersTable.pickupPoint !== item.pickupPoint) && item.transfersTable.pickupTimeSaved === false && item.transfersTable.pickupPointSaved === false && item.transfersTable.saving === false;
	      });
	      if (transferToUpdate.length === 0) {
	        return;
	      }
	
	      this.toogleLoaderAndSumbit(transferToUpdate);
	      this.transfersTableService.saveTransfers(this.transfersTableService.transferCollectionDataTransformerRequest(transferToUpdate, this.formatDate)).then(function (response) {
	        if (response === null) {
	          return transferToUpdate.map(function (item) {
	            item.transfersTable.pickupTimeSaved = true;
	            item.transfersTable.pickupPointSaved = true;
	          });
	        }
	
	        transferToUpdate.forEach(function (item) {
	          item.transfersTable.pickupTimeSaved = response[item.transferId] || false;
	          item.transfersTable.pickupPointSaved = response[item.transferId] || false;
	        });
	      })['finally'](function () {
	        _this3.toogleLoaderAndSumbit(transferToUpdate);
	      });
	    }
	
	    //TODO Move to a filter
	  }, {
	    key: 'formatDateToString',
	    value: function formatDateToString(timestamp) {
	      var myDate = new Date(timestamp);
	      return this.transfersTableFilter(myDate) + ' at ' + myDate.toLocaleTimeString('en-US', {
	        hour12: false,
	        hour: "numeric",
	        minute: "numeric"
	      });
	    }
	  }, {
	    key: 'checkDates',
	    value: function checkDates(item) {
	      // If no pickupTime set FlightTime as defaults
	      if (item.pickupTime) {
	        this.setDatePickerOptions(item, item.pickupTime);
	      } else {
	        this.setDatePickerOptions(item, item.flightTime);
	      }
	    }
	  }, {
	    key: 'setDatePickerOptions',
	    value: function setDatePickerOptions(item, date) {
	      //Set initDate, maxDate and dateModel
	      item.transfersTable.datePicker.options.initDate = item.flightTime;
	      item.transfersTable.flightTimeDateConcat = this.formatDateToString(item.flightTime);
	      item.transfersTable.datePicker.options.dateModel = new Date(date);
	      item.transfersTable.pickupTimeDateConcat = this.formatDateToString(date);
	      item.transfersTable.shuttleLatestPickupTime = this.formatDateToString(item.shuttleLatestPickupTime);
	      item.transfersTable.latestPickupTimeDateConcat = this.formatDateToString(item.latestPickupTime);
	      item.transfersTable.earliestPickupTimeDateConcat = this.formatDateToString(item.earliestPickupTime);
	    }
	  }, {
	    key: 'isPickupTimeValid',
	    value: function isPickupTimeValid(item) {
	      return item.transfersTable.timePicker.model >= item.transfersTable.timePicker.min && item.transfersTable.timePicker.model <= item.transfersTable.timePicker.max;
	    }
	  }, {
	    key: 'saveFieldDate',
	    value: function saveFieldDate(item, $event) {
	      $event.stopPropagation();
	      $event.preventDefault();
	
	      item.transfersTable.dropdownIsOpen = false;
	      item.transfersTable.datePicker.options.isOpen = false;
	
	      var model = undefined;
	      if (item.labelType > 0) {
	        item.transfersTable.datePicker.options.dateModel.setHours(item.transfersTable.timePicker.model.getHours());
	        item.transfersTable.datePicker.options.dateModel.setMinutes(item.transfersTable.timePicker.model.getMinutes());
	        model = item.transfersTable.datePicker.options.dateModel;
	      } else {
	        model = item.transfersTable.timePicker.model;
	      }
	      item.pickupTime = model;
	      item.transfersTable.pickupTimeDateConcat = this.formatDateToString(model);
	    }
	  }, {
	    key: 'toggleDropdownOffClick',
	    value: function toggleDropdownOffClick(item) {
	      item.transfersTable.datePicker.options.isOpen = false;
	      item.transfersTable.dropdownIsOpen = false;
	      item.transfersTable.pointPicker.options.isOpen = false;
	      item.transfersTable.dropdownPickupPointIsOpen = false;
	    }
	  }, {
	    key: 'toggleDatePicker',
	    value: function toggleDatePicker(item, $event) {
	      $event.stopPropagation();
	      $event.preventDefault();
	      item.transfersTable.datePicker.options.isOpen = !item.transfersTable.datePicker.options.isOpen;
	    }
	  }, {
	    key: 'togglePickupPointEdit',
	    value: function togglePickupPointEdit(item, $event) {
	      $event.stopPropagation();
	      $event.preventDefault();
	
	      if (item.transfersTable.saving) {
	        item.transfersTable.dropdownPickupPointIsOpen = false;
	        return;
	      }
	
	      item.transfersTable.dropdownPickupPointIsOpen = !item.transfersTable.dropdownPickupPointIsOpen;
	      item.transfersTable.tempPickupPoint = item.pickupPoint;
	    }
	  }, {
	    key: 'savePickupPoint',
	    value: function savePickupPoint(item, $event) {
	      $event.stopPropagation();
	      $event.preventDefault();
	
	      item.pickupPoint = item.transfersTable.tempPickupPoint;
	      item.transfersTable.dropdownPickupPointIsOpen = false;
	    }
	  }, {
	    key: 'togglePickupTimeDropdown',
	    value: function togglePickupTimeDropdown($event, item) {
	      $event.stopPropagation();
	      $event.preventDefault();
	      if (item.transfersTable.saving) {
	        item.transfersTable.dropdownIsOpen = false;
	        return;
	      }
	
	      item.transfersTable.dropdownIsOpen = !item.transfersTable.dropdownIsOpen;
	    }
	  }, {
	    key: 'downloadExcel',
	    value: function downloadExcel() {
	      var _this4 = this;
	
	      this.toggleLoader();
	      var endDate = this.moment().add(6, 'days').format(this.filterDateFormat);
	      var onlyTransfersWithoutPickupTime = this.leftFilterName && this.leftFilterName.pickupTime ? 1 : 0;
	      this.transfersTableService.downloadTransfersExcel(this.getSelectedGatewayIds(), endDate, this.getSelectedGatewayCod(), onlyTransfersWithoutPickupTime)['finally'](function () {
	        return _this4.toggleLoader();
	      });
	    }
	  }, {
	    key: 'uploadExcel',
	    value: function uploadExcel() {
	      var _this5 = this;
	
	      var fileInput = document.getElementById('fileInput');
	
	      if (!fileInput || !fileInput.files.length) {
	        this.$timeout(function () {
	          _this5.uploadMessage = "Please select a file before uploading.";
	          _this5.uploadSuccess = false;
	          _this5.showPopup = true;
	        });
	        return;
	      }
	
	      this.isUploading = true; // Disable button
	      var file = fileInput.files[0];
	      this.uploadFileName = file.name;
	
	      var formData = new FormData();
	      formData.append('transfers_file', file);
	
	      this.transfersTableService.uploadTransfersExcel(formData).then(function (data) {
	        _this5.$timeout(function () {
	          if (data && data.success) {
	            var updatedCount = data.summary.updated_entities.length;
	            var totalCount = data.summary.entities_to_update.length;
	
	            var messageTitle = "All transfers updated successfully.";
	            var warningMessage = 'Possible reasons:<br>\n              - Invalid Transfer Reference. Valid formats are: SUNTR_XX0000/1 or SUNTR_XX0000/2 <br>\n              - Invalid Pickup Time. Valid format is: year-month-day hour:minute, e.g. 2025-03-25 17:50 <br>\n              - No changes were made: You\'re updating the Pickup Time to a time that was already set.';
	
	            var messageStyle = "success";
	            if (updatedCount === 0) {
	              messageTitle = "Attention: No transfers were updated.";
	              messageStyle = "warning";
	            } else if (updatedCount !== totalCount) {
	              messageTitle = 'Attention: Transfers updated out of ' + totalCount + ': ' + updatedCount;
	              messageStyle = "warning";
	            }
	
	            var message = messageTitle;
	            if (messageStyle === "warning") {
	              message += "<br><br>" + warningMessage;
	            }
	
	            _this5.uploadMessage = _this5.$sce.trustAsHtml(message);
	            _this5.uploadSuccess = true;
	            _this5.style = messageStyle;
	          } else {
	            _this5.uploadMessage = _this5.$sce.trustAsHtml('❌ Upload failed for \'' + _this5.uploadFileName + '\'. Review the file or contact devops@suntransfers.com.');
	            _this5.uploadSuccess = false;
	            _this5.style = "error";
	          }
	          _this5.showPopup = true;
	          _this5.isUploading = false;
	        });
	      })['catch'](function (error) {
	        _this5.$timeout(function () {
	          _this5.uploadMessage = _this5.$sce.trustAsHtml('❌ Error occurred while processing the file. Please try again later.');
	          _this5.uploadSuccess = false;
	          _this5.style = "error";
	          _this5.showPopup = true;
	          _this5.isUploading = false;
	        });
	      });
	    }
	  }, {
	    key: 'closePopup',
	    value: function closePopup() {
	      this.showPopup = false;
	      window.location.reload();
	    }
	  }, {
	    key: 'handleGatewayChange',
	    value: function handleGatewayChange(selectedGateway) {
	      this.gateways.selectedGateway = selectedGateway;
	      var endDate = this.moment().add(6, 'days').format(this.filterDateFormat);
	      if (this.gateways.selectedGateway === 'all') {
	        this.getTransfersByGateway(this.gateways.gatewayIds, endDate);
	      } else {
	        this.getTransfersByGateway(this.gateways.selectedGateway, endDate);
	      }
	    }
	  }, {
	    key: 'handleFilterChange',
	    value: function handleFilterChange(selectedFilter) {
	      this.leftFilterName = selectedFilter.name;
	    }
	  }, {
	    key: 'getSelectedGatewayIds',
	    value: function getSelectedGatewayIds() {
	      return this.gateways.selectedGateway === undefined || this.gateways.selectedGateway === "all" ? this.gateways.gatewayIds : this.gateways.selectedGateway;
	    }
	  }, {
	    key: 'getSelectedGatewayCod',
	    value: function getSelectedGatewayCod() {
	      var _this6 = this;
	
	      var gateway = this.gateways.find(function (g) {
	        return g.id === _this6.gateways.selectedGateway;
	      });
	      return gateway ? gateway.cod : "ALL";
	    }
	  }]);
	
	  return TransfersTableController;
	})();
	
	exports['default'] = TransfersTableController;
	module.exports = exports['default'];

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _jsonConfigApiSuppliersJson = __webpack_require__(29);
	
	var _jsonConfigApiSuppliersJson2 = _interopRequireDefault(_jsonConfigApiSuppliersJson);
	
	var transfersTableService = (function () {
	    transfersTableService.$inject = ["$http", "cacheService", "apiTransfersService", "moment"];
	    function transfersTableService($http, cacheService, apiTransfersService, moment) {
	        'ngInject';
	
	        _classCallCheck(this, transfersTableService);
	
	        this.$http = $http;
	        this.apiTransfersService = apiTransfersService;
	        this.cacheService = cacheService;
	        this.moment = moment;
	
	        this.transfersByGatewayParams = {
	            'init_date': null, // Forcing null this property doesn't send as querystring
	            'end_date': null,
	            'suppliers': null,
	            'gateways': null,
	            'has_only_ratecards_for_shuttles': 1,
	            'has_only_transfers_without_pickup_time': 0,
	            'force_from_hotel_to_airport': 1
	        };
	    }
	
	    _createClass(transfersTableService, [{
	        key: 'setSupplier',
	        value: function setSupplier(id) {
	            this.transfersByGatewayParams.suppliers = id;
	        }
	    }, {
	        key: 'setGateway',
	        value: function setGateway(id) {
	            this.transfersByGatewayParams.gateways = id;
	        }
	    }, {
	        key: 'setEndDate',
	        value: function setEndDate(endDate) {
	            this.transfersByGatewayParams.end_date = endDate;
	        }
	    }, {
	        key: 'getGateways',
	        value: function getGateways() {
	            var supplierId = this.cacheService.get('supplier').supplierId;
	            this.setSupplier(supplierId);
	            return this.apiTransfersService.gatewaysBySupplier.get({ suppliers: supplierId }).$promise;
	        }
	    }, {
	        key: 'getTransfersByGateway',
	        value: function getTransfersByGateway(gatewayId, formatDate, endDate) {
	            var _this = this;
	
	            this.setGateway(gatewayId);
	            endDate = endDate || null;
	            this.setEndDate(endDate);
	            return this.apiTransfersService.transfersBySupplierAndGateway.get(this.transfersByGatewayParams).$promise.then(function (response) {
	                return _this.transferCollecitonDataTransformerResponse(response.transfers, formatDate);
	            });
	        }
	    }, {
	        key: 'transferCollecitonDataTransformerResponse',
	        value: function transferCollecitonDataTransformerResponse(data, formatDate) {
	            var _this2 = this;
	
	            //TODO: data transform
	            return data.map(function (item) {
	
	                var flightTime = _this2.moment(item.flightTime, formatDate);
	                var timePicker = _this2.moment(item.latestPickupTime.date);
	                var shuttleTimePicker = _this2.moment(item.shuttleLatestPickupTime.date);
	                var earliestDateTime = _this2.moment(item.earliestPickupTime.date);
	                var tempPickupPoint = item.pickupPoint;
	
	                item.flightTime = flightTime.valueOf();
	                item.latestPickupTime = timePicker.valueOf();
	                item.shuttleLatestPickupTime = shuttleTimePicker.valueOf();
	                item.earliestPickupTime = earliestDateTime.valueOf();
	
	                if (item.pickupTime) {
	                    var pickupTime = _this2.moment(item.pickupTime, formatDate);
	                    item.pickupTime = pickupTime.valueOf();
	                }
	
	                var timePickerMin = earliestDateTime.clone().toDate();
	                var timePickerMax = shuttleTimePicker.clone().toDate();
	                var timePickerModel = timePicker.clone().toDate();
	
	                item.transfersTable = {
	                    //pickupTimeSaved to false allows modifying already stored pickupTimes manually
	                    pickupTimeSaved: false,
	                    pickupPointSaved: false,
	                    pickupPoint: tempPickupPoint,
	                    tempPickupPoint: tempPickupPoint,
	                    datePicker: {
	                        options: {
	                            showWeeks: false,
	                            dateModel: null,
	                            isOpen: false,
	                            maxDate: timePickerMax,
	                            minDate: timePickerMin
	                        }
	                    },
	                    timePicker: {
	                        max: timePickerMax,
	                        min: timePickerMin,
	                        model: timePickerModel
	                    },
	                    pointPicker: {
	                        options: {
	                            isOpen: false
	                        }
	                    },
	                    dropdownIsOpen: false,
	                    dropdownPickupPointIsOpen: false,
	                    saving: false
	                };
	                return item;
	            });
	        }
	    }, {
	        key: 'transferItemDataTransformer',
	        value: function transferItemDataTransformer(id, timestamp, formatDate, pickupPoint) {
	            return {
	                op: 'replace',
	                path: '/transfers/' + id,
	                value: {
	                    pickupDateTime: this.moment(timestamp).format(formatDate),
	                    pickupPoint: pickupPoint
	                }
	            };
	        }
	    }, {
	        key: 'transferCollectionDataTransformerRequest',
	        value: function transferCollectionDataTransformerRequest(transfers, formatDate) {
	            var _this3 = this;
	
	            return transfers.map(function (item) {
	                return _this3.transferItemDataTransformer(item.transferId, item.pickupTime.valueOf(), formatDate, item.pickupPoint);
	            });
	        }
	    }, {
	        key: 'saveTransfers',
	        value: function saveTransfers(transfers) {
	            return this.apiTransfersService.saveTransfers({ 'items': transfers });
	        }
	    }, {
	        key: 'downloadTransfersExcel',
	        value: function downloadTransfersExcel(gatewayIds, endDate, gatewayCod, onlyTransfersWithoutPickupTime) {
	            this.setGateway(gatewayIds);
	            endDate = endDate || null;
	            this.setEndDate(endDate);
	
	            var supplierId = this.transfersByGatewayParams.suppliers;
	            var gatewayId = this.transfersByGatewayParams.gateways;
	
	            if (!supplierId || !gatewayId) {
	                return;
	            }
	
	            this.transfersByGatewayParams.has_only_transfers_without_pickup_time = onlyTransfersWithoutPickupTime;
	
	            var url = _jsonConfigApiSuppliersJson2['default'].baseUrl + _jsonConfigApiSuppliersJson2['default'].endpoint.downloadTransfersExcel.replace(':suppliers', supplierId).replace(':gateways', gatewayId);
	
	            return this.$http({
	                method: 'GET',
	                url: url,
	                params: this.transfersByGatewayParams,
	                responseType: 'arraybuffer'
	            }).then(function (response) {
	                var date = new Date();
	                var formattedDate = date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0') + '_' + String(date.getHours()).padStart(2, '0') + '-' + String(date.getMinutes()).padStart(2, '0') + '-' + String(date.getSeconds()).padStart(2, '0');
	
	                var fileName = gatewayCod + '_' + formattedDate + '_upcoming_shuttle_transfer.xlsx';
	                var blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
	                var link = document.createElement('a');
	                link.href = window.URL.createObjectURL(blob);
	                link.download = fileName;
	                document.body.appendChild(link);
	                link.click();
	                document.body.removeChild(link);
	            })['catch'](function (error) {
	                window.alert("Error downloading file. Please try again.");
	            });
	        }
	    }, {
	        key: 'uploadTransfersExcel',
	        value: function uploadTransfersExcel(formData) {
	            var supplierId = this.transfersByGatewayParams.suppliers;
	            var url = _jsonConfigApiSuppliersJson2['default'].baseUrl + _jsonConfigApiSuppliersJson2['default'].endpoint.uploadTransfersExcel.replace(':suppliers', supplierId);
	
	            return this.$http({
	                method: 'POST',
	                url: url,
	                data: formData,
	                headers: { 'Content-Type': undefined }
	            }).then(function (response) {
	                return response.data;
	            })['catch'](function (error) {
	                window.alert("Error uploading file. Please try again.");
	            });
	        }
	    }]);
	
	    return transfersTableService;
	})();
	
	exports['default'] = transfersTableService;
	module.exports = exports['default'];

/***/ },
/* 29 */,
/* 30 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	var transfersTableFilter = function transfersTableFilter() {
	    return function (timestamp) {
	        var date = new Date(timestamp);
	        var dateObject = date.getFullYear() + '/' + ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2);
	        return dateObject;
	    };
	};
	exports['default'] = transfersTableFilter;
	module.exports = exports['default'];

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularResource = __webpack_require__(32);
	
	var _angularResource2 = _interopRequireDefault(_angularResource);
	
	var _jsonConfigApiSuppliersJson = __webpack_require__(29);
	
	var _jsonConfigApiSuppliersJson2 = _interopRequireDefault(_jsonConfigApiSuppliersJson);
	
	var ApiTransfersService = (function () {
	  ApiTransfersService.$inject = ["$resource", "$http", "$translate"];
	  function ApiTransfersService($resource, $http, $translate) {
	    'ngInject';
	
	    _classCallCheck(this, ApiTransfersService);
	
	    this.$http = $http;
	    this.transfersBySupplierAndGateway = $resource(_jsonConfigApiSuppliersJson2['default'].baseUrl + _jsonConfigApiSuppliersJson2['default'].endpoint.transfersBySupplierAndGateway, {
	      'suppliers': '@suppliers',
	      'gateways': '@gateways',
	      'init_date': 'init_date',
	      'end_date': 'end_date',
	      'has_only_ratecards_for_shuttles': 'has_only_ratecards_for_shuttles',
	      'force_from_hotel_to_airport': 'force_from_hotel_to_airport'
	    }, {
	      get: {
	        method: "GET", headers: {
	          "Accept-Language": $translate.use()
	        }
	      }
	    });
	
	    this.gatewaysBySupplier = $resource(_jsonConfigApiSuppliersJson2['default'].baseUrl + _jsonConfigApiSuppliersJson2['default'].endpoint.gatewaysBySupplier, {
	      'suppliers': '@suppliers'
	    }, {
	      get: {
	        method: "GET",
	        headers: {
	          "Accept-Language": $translate.use()
	        }
	      }
	    });
	
	    this.downloadTransfersExcel = $resource(_jsonConfigApiSuppliersJson2['default'].baseUrl + _jsonConfigApiSuppliersJson2['default'].endpoint.downloadTransfersExcel, {
	      'suppliers': '@suppliers',
	      'gateways': '@gateways',
	      'init_date': 'init_date',
	      'end_date': 'end_date'
	    }, {
	      get: {
	        method: "GET",
	        responseType: 'arraybuffer',
	        headers: {
	          "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
	          "Accept-Language": $translate.use()
	        }
	      }
	    });
	  }
	
	  _createClass(ApiTransfersService, [{
	    key: 'saveTransfers',
	    value: function saveTransfers(data) {
	      var status = {
	        'success': 1,
	        'error': 0
	      };
	      return this.$http.patch(_jsonConfigApiSuppliersJson2['default'].baseUrl + _jsonConfigApiSuppliersJson2['default'].endpoint.transfers, data).then(function (response) {
	        if (response.status === 204) {
	          return null;
	        }
	        var transfersStatus = response.data.items.reduce(function (items, item) {
	          items[item.index] = status[item.status];
	          return items;
	        }, {});
	        return transfersStatus;
	      });
	    }
	  }]);
	
	  return ApiTransfersService;
	})();
	
	var apiTransfersModule = _angular2['default'].module('api.suppliers.transfers', [_angularResource2['default']]).service('apiTransfersService', ApiTransfersService).name;
	
	exports['default'] = apiTransfersModule;
	module.exports = exports['default'];

/***/ },
/* 32 */,
/* 33 */,
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	//TODO Use a factory to load weakMap or (local|session)storage
	
	var CacheService = (function () {
	    function CacheService() {
	        _classCallCheck(this, CacheService);
	
	        //TODO use WeakMap
	        this._wm = {};
	
	        this.prefix = "st_";
	        this.storage = localStorage;
	        this.isLocalStorageActive = this.isLocalStorageSupported();
	    }
	
	    _createClass(CacheService, [{
	        key: 'isLocalStorageSupported',
	        value: function isLocalStorageSupported() {
	            try {
	                var testKey = 'test';
	                this.storage.setItem(testKey, '1');
	                this.storage.removeItem(testKey);
	                return true;
	            } catch (error) {
	                return false;
	            }
	        }
	    }, {
	        key: 'get',
	        value: function get(key) {
	            var value = false;
	            if (!this.isLocalStorageActive) {
	                value = this._wm[key] || false;
	                if (value) {
	                    value = _angular2['default'].fromJson(value);
	                }
	                return value;
	            }
	
	            value = this.storage.getItem(key);
	            if (!value) {
	                return false;
	            }
	
	            return _angular2['default'].fromJson(value);
	        }
	    }, {
	        key: 'set',
	        value: function set(key, value) {
	            if (!this.isLocalStorageActive) {
	                this._wm[key] = _angular2['default'].toJson(value);
	            }
	            this.storage.setItem(key, _angular2['default'].toJson(value));
	        }
	    }, {
	        key: 'delete',
	        value: function _delete(key) {
	            if (!this.isLocalStorageActive) {
	                delete this._wm[key];
	            }
	            this.storage.removeItem(key);
	        }
	    }]);
	
	    return CacheService;
	})();
	
	var cacheServiceModule = _angular2['default'].module('st.services.cache', []).service('cacheService', CacheService).name;
	
	exports['default'] = cacheServiceModule;
	module.exports = exports['default'];

/***/ },
/* 35 */,
/* 36 */,
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 38,
		"./af.js": 38,
		"./ar": 39,
		"./ar-dz": 40,
		"./ar-dz.js": 40,
		"./ar-kw": 41,
		"./ar-kw.js": 41,
		"./ar-ly": 42,
		"./ar-ly.js": 42,
		"./ar-ma": 43,
		"./ar-ma.js": 43,
		"./ar-sa": 44,
		"./ar-sa.js": 44,
		"./ar-tn": 45,
		"./ar-tn.js": 45,
		"./ar.js": 39,
		"./az": 46,
		"./az.js": 46,
		"./be": 47,
		"./be.js": 47,
		"./bg": 48,
		"./bg.js": 48,
		"./bm": 49,
		"./bm.js": 49,
		"./bn": 50,
		"./bn.js": 50,
		"./bo": 51,
		"./bo.js": 51,
		"./br": 52,
		"./br.js": 52,
		"./bs": 53,
		"./bs.js": 53,
		"./ca": 54,
		"./ca.js": 54,
		"./cs": 55,
		"./cs.js": 55,
		"./cv": 56,
		"./cv.js": 56,
		"./cy": 57,
		"./cy.js": 57,
		"./da": 58,
		"./da.js": 58,
		"./de": 59,
		"./de-at": 60,
		"./de-at.js": 60,
		"./de-ch": 61,
		"./de-ch.js": 61,
		"./de.js": 59,
		"./dv": 62,
		"./dv.js": 62,
		"./el": 63,
		"./el.js": 63,
		"./en-au": 64,
		"./en-au.js": 64,
		"./en-ca": 65,
		"./en-ca.js": 65,
		"./en-gb": 66,
		"./en-gb.js": 66,
		"./en-ie": 67,
		"./en-ie.js": 67,
		"./en-nz": 68,
		"./en-nz.js": 68,
		"./eo": 69,
		"./eo.js": 69,
		"./es": 70,
		"./es-do": 71,
		"./es-do.js": 71,
		"./es-us": 72,
		"./es-us.js": 72,
		"./es.js": 70,
		"./et": 73,
		"./et.js": 73,
		"./eu": 74,
		"./eu.js": 74,
		"./fa": 75,
		"./fa.js": 75,
		"./fi": 76,
		"./fi.js": 76,
		"./fo": 77,
		"./fo.js": 77,
		"./fr": 78,
		"./fr-ca": 79,
		"./fr-ca.js": 79,
		"./fr-ch": 80,
		"./fr-ch.js": 80,
		"./fr.js": 78,
		"./fy": 81,
		"./fy.js": 81,
		"./gd": 82,
		"./gd.js": 82,
		"./gl": 83,
		"./gl.js": 83,
		"./gom-latn": 84,
		"./gom-latn.js": 84,
		"./gu": 85,
		"./gu.js": 85,
		"./he": 86,
		"./he.js": 86,
		"./hi": 87,
		"./hi.js": 87,
		"./hr": 88,
		"./hr.js": 88,
		"./hu": 89,
		"./hu.js": 89,
		"./hy-am": 90,
		"./hy-am.js": 90,
		"./id": 91,
		"./id.js": 91,
		"./is": 92,
		"./is.js": 92,
		"./it": 93,
		"./it.js": 93,
		"./ja": 94,
		"./ja.js": 94,
		"./jv": 95,
		"./jv.js": 95,
		"./ka": 96,
		"./ka.js": 96,
		"./kk": 97,
		"./kk.js": 97,
		"./km": 98,
		"./km.js": 98,
		"./kn": 99,
		"./kn.js": 99,
		"./ko": 100,
		"./ko.js": 100,
		"./ky": 101,
		"./ky.js": 101,
		"./lb": 102,
		"./lb.js": 102,
		"./lo": 103,
		"./lo.js": 103,
		"./lt": 104,
		"./lt.js": 104,
		"./lv": 105,
		"./lv.js": 105,
		"./me": 106,
		"./me.js": 106,
		"./mi": 107,
		"./mi.js": 107,
		"./mk": 108,
		"./mk.js": 108,
		"./ml": 109,
		"./ml.js": 109,
		"./mr": 110,
		"./mr.js": 110,
		"./ms": 111,
		"./ms-my": 112,
		"./ms-my.js": 112,
		"./ms.js": 111,
		"./my": 113,
		"./my.js": 113,
		"./nb": 114,
		"./nb.js": 114,
		"./ne": 115,
		"./ne.js": 115,
		"./nl": 116,
		"./nl-be": 117,
		"./nl-be.js": 117,
		"./nl.js": 116,
		"./nn": 118,
		"./nn.js": 118,
		"./pa-in": 119,
		"./pa-in.js": 119,
		"./pl": 120,
		"./pl.js": 120,
		"./pt": 121,
		"./pt-br": 122,
		"./pt-br.js": 122,
		"./pt.js": 121,
		"./ro": 123,
		"./ro.js": 123,
		"./ru": 124,
		"./ru.js": 124,
		"./sd": 125,
		"./sd.js": 125,
		"./se": 126,
		"./se.js": 126,
		"./si": 127,
		"./si.js": 127,
		"./sk": 128,
		"./sk.js": 128,
		"./sl": 129,
		"./sl.js": 129,
		"./sq": 130,
		"./sq.js": 130,
		"./sr": 131,
		"./sr-cyrl": 132,
		"./sr-cyrl.js": 132,
		"./sr.js": 131,
		"./ss": 133,
		"./ss.js": 133,
		"./sv": 134,
		"./sv.js": 134,
		"./sw": 135,
		"./sw.js": 135,
		"./ta": 136,
		"./ta.js": 136,
		"./te": 137,
		"./te.js": 137,
		"./tet": 138,
		"./tet.js": 138,
		"./th": 139,
		"./th.js": 139,
		"./tl-ph": 140,
		"./tl-ph.js": 140,
		"./tlh": 141,
		"./tlh.js": 141,
		"./tr": 142,
		"./tr.js": 142,
		"./tzl": 143,
		"./tzl.js": 143,
		"./tzm": 144,
		"./tzm-latn": 145,
		"./tzm-latn.js": 145,
		"./tzm.js": 144,
		"./uk": 146,
		"./uk.js": 146,
		"./ur": 147,
		"./ur.js": 147,
		"./uz": 148,
		"./uz-latn": 149,
		"./uz-latn.js": 149,
		"./uz.js": 148,
		"./vi": 150,
		"./vi.js": 150,
		"./x-pseudo": 151,
		"./x-pseudo.js": 151,
		"./yo": 152,
		"./yo.js": 152,
		"./zh-cn": 153,
		"./zh-cn.js": 153,
		"./zh-hk": 154,
		"./zh-hk.js": 154,
		"./zh-tw": 155,
		"./zh-tw.js": 155
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 37;


/***/ },
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	// TODO: rename module
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _stSelectComponent = __webpack_require__(157);
	
	var _stSelectComponent2 = _interopRequireDefault(_stSelectComponent);
	
	var stSelectModule = _angular2['default'].module('stSelect', [_angularUiRouter2['default']]).component('stSelect', _stSelectComponent2['default']).name;
	
	exports['default'] = stSelectModule;
	module.exports = exports['default'];

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _stSelectHtml = __webpack_require__(158);
	
	var _stSelectHtml2 = _interopRequireDefault(_stSelectHtml);
	
	var _stSelectController = __webpack_require__(159);
	
	var _stSelectController2 = _interopRequireDefault(_stSelectController);
	
	var stSelectComponent = {
	  restrict: 'E',
	  bindings: {
	    items: '=',
	    getTransfers: '&'
	  },
	  template: _stSelectHtml2['default'],
	  controller: _stSelectController2['default'],
	  controllerAs: 'vm'
	};
	
	exports['default'] = stSelectComponent;
	module.exports = exports['default'];

/***/ },
/* 158 */
/***/ function(module, exports) {

	module.exports = "<div class=\"{{ vm.name }}\">\n  <div class=\"btn-group\" uib-dropdown is-open=\"status.isopen\">\n   <button id=\"single-button\" type=\"button\" class=\"btn btn-link\" uib-dropdown-toggle ng-disabled=\"disabled\">\n   {{vm.dropText | translate}}<span class=\"st-icon-chevron-down st-icon-chevron-down-sm-button\"></span>\n   </button>\n   <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\">\n      <li ng-repeat=\"item in vm.items\">\n          <a href=\"\" ng-click=\"vm.toggleDropdown(item)\">{{item.name | translate}}</a>\n      </li>\n   </ul>\n </div>\n</div>\n"

/***/ },
/* 159 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var StSelectController = (function () {
	  StSelectController.$inject = ["$translate", "transfersTableService"];
	  function StSelectController($translate, transfersTableService) {
	    'ngInject';
	    // TODO: tranlations
	
	    _classCallCheck(this, StSelectController);
	
	    this.$translate = $translate;
	    this.name = 'stSelect';
	    this.transfersTableService = transfersTableService;
	    this.dropText = this.$translate.instant(this.items[0].name);
	  }
	
	  _createClass(StSelectController, [{
	    key: 'toggleDropdown',
	    value: function toggleDropdown(item) {
	      this.getTransfers({ gateway: item.id });
	      this.dropText = this.$translate.instant(item.name);
	    }
	  }]);
	
	  return StSelectController;
	})();
	
	exports['default'] = StSelectController;
	module.exports = exports['default'];

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	// TODO: rename module
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _stSelectFilterComponent = __webpack_require__(161);
	
	var _stSelectFilterComponent2 = _interopRequireDefault(_stSelectFilterComponent);
	
	var stSelectFilterModule = _angular2['default'].module('stSelectFilter', [_angularUiRouter2['default']]).component('stSelectFilter', _stSelectFilterComponent2['default']).name;
	
	exports['default'] = stSelectFilterModule;
	module.exports = exports['default'];

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _stSelectFilterHtml = __webpack_require__(162);
	
	var _stSelectFilterHtml2 = _interopRequireDefault(_stSelectFilterHtml);
	
	var _stSelectFilterController = __webpack_require__(163);
	
	var _stSelectFilterController2 = _interopRequireDefault(_stSelectFilterController);
	
	var stSelectFilterComponent = {
	  restrict: 'E',
	  bindings: {
	    filter: '=',
	    items: '='
	  },
	  template: _stSelectFilterHtml2['default'],
	  controller: _stSelectFilterController2['default'],
	  controllerAs: 'vm'
	};
	
	exports['default'] = stSelectFilterComponent;
	module.exports = exports['default'];

/***/ },
/* 162 */
/***/ function(module, exports) {

	module.exports = "<div class=\"{{ vm.name }}\">\n  <div class=\"btn-group\" uib-dropdown is-open=\"status.isopen\">\n   <button id=\"single-button\" type=\"button\" class=\"btn btn-link\" uib-dropdown-toggle ng-disabled=\"disabled\">\n   {{vm.dropText | translate}}<span class=\"st-icon-chevron-down st-icon-chevron-down-sm-button\"></span>\n   </button>\n   <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\">\n      <li ng-repeat=\"item in vm.items\">\n        <a href=\"\" ng-click=\"vm.toggleFilter(item, filter)\" >{{item.name | translate}}</a>\n      </li>\n   </ul>\n </div>\n</div>\n"

/***/ },
/* 163 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var StSelectFilterController = (function () {
	  StSelectFilterController.$inject = ["$translate"];
	  function StSelectFilterController($translate) {
	    'ngInject';
	
	    _classCallCheck(this, StSelectFilterController);
	
	    this.$translate = $translate;
	    this.name = 'stSelect';
	    this.dropText = this.$translate.instant(this.items[0].name);
	  }
	
	  _createClass(StSelectFilterController, [{
	    key: 'toggleFilter',
	    value: function toggleFilter(item) {
	      this.dropText = this.$translate.instant(item.name);
	      this.filter = item.filter;
	    }
	  }]);
	
	  return StSelectFilterController;
	})();
	
	exports['default'] = StSelectFilterController;
	module.exports = exports['default'];

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	        value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _angularOauth2 = __webpack_require__(165);
	
	var _angularOauth22 = _interopRequireDefault(_angularOauth2);
	
	var _authConfig = __webpack_require__(171);
	
	var _authConfig2 = _interopRequireDefault(_authConfig);
	
	var _authRun = __webpack_require__(173);
	
	var _authRun2 = _interopRequireDefault(_authRun);
	
	var _authService = __webpack_require__(174);
	
	var _authService2 = _interopRequireDefault(_authService);
	
	var authModule = _angular2['default'].module('authService', [_angularUiRouter2['default'], _angularOauth22['default'].name]).config(_authConfig2['default']).run(_authRun2['default']).service('authService', _authService2['default']).name;
	
	exports['default'] = authModule;
	module.exports = exports['default'];

/***/ },
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _jsonConfigOauthJson = __webpack_require__(172);
	
	var _jsonConfigOauthJson2 = _interopRequireDefault(_jsonConfigOauthJson);
	
	var authConfig = function authConfig(OAuthProvider, OAuthTokenProvider) {
	    "ngInject";
	
	    OAuthProvider.configure(_jsonConfigOauthJson2['default']);
	
	    OAuthTokenProvider.configure({
	        name: 'token',
	        options: {
	            secure: false
	        }
	    });
	};
	authConfig.$inject = ["OAuthProvider", "OAuthTokenProvider"];
	
	exports['default'] = authConfig;
	module.exports = exports['default'];

/***/ },
/* 172 */,
/* 173 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var authRun = function authRun($rootScope, $state, $window, OAuth, sharedService) {
	  "ngInject";
	  $rootScope.$on('oauth:error', function (event, rejection) {
	
	    // Ignore `invalid_grant` error - should be catched on `LoginController`.
	    if ('invalid_grant' === rejection.data.error && 400 === rejection.status && $state.is('auth.login')) {
	      return;
	    }
	
	    // Refresh token when a `invalid_token` error or a `invalid_grant` error and status 400 occurs
	    if ('invalid_token' === rejection.data.error ||
	    // Patch related with: https://github.com/oauthjs/angular-oauth2/issues/32
	    401 === rejection.status && 'invalid_grant' === rejection.data.error) {
	      if (sharedService.refreshingToken) {
	        return;
	      }
	      sharedService.refreshingToken = true;
	      return OAuth.getRefreshToken().then(function () {
	        sharedService.refreshingToken = false;
	        $state.reload('home');
	      });
	    }
	
	    // Redirect to `/login` with the `error_reason`.
	    $state.go('auth.login', { 'error_reason': rejection.data.error });
	    event.preventDefault();
	  });
	
	  $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams) {
	    if (!OAuth.isAuthenticated() && toState.name !== 'auth.login') {
	      // User isn’t authenticated
	      $state.go('auth.login');
	      event.preventDefault();
	    }
	  });
	};
	authRun.$inject = ["$rootScope", "$state", "$window", "OAuth", "sharedService"];
	
	exports['default'] = authRun;
	module.exports = exports['default'];

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _jsonConfigOauthJson = __webpack_require__(172);
	
	var _jsonConfigOauthJson2 = _interopRequireDefault(_jsonConfigOauthJson);
	
	var _queryString = __webpack_require__(175);
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var AuthService = (function () {
	  AuthService.$inject = ["$state", "$http", "OAuth", "OAuthToken"];
	  function AuthService($state, $http, OAuth, OAuthToken) {
	    'ngInject';
	
	    _classCallCheck(this, AuthService);
	
	    this.$state = $state;
	    this.$http = $http;
	    this.OAuth = OAuth;
	    this.OAuthToken = OAuthToken;
	    this.authenticated = this.OAuth.isAuthenticated();
	  }
	
	  _createClass(AuthService, [{
	    key: 'login',
	    value: function login(username, password) {
	      var _this = this;
	
	      //authenticate and set the auth header
	      var credentials = { username: username, password: password };
	      return this.OAuth.getAccessToken(credentials).then(function (response) {
	        _this.authenticated = true;
	        return response;
	      });
	    }
	
	    // TODO Create a PR in angular-oauth2 revoking access_token and refresh_token
	  }, {
	    key: 'revokeAccessToken',
	    value: function revokeAccessToken(accessToken) {
	      var data = {
	        client_id: _jsonConfigOauthJson2['default'].clientId,
	        token_type_hint: 'access_token',
	        token: accessToken
	      };
	
	      if (null !== _jsonConfigOauthJson2['default'].clientSecret) {
	        data.client_secret = _jsonConfigOauthJson2['default'].clientSecret;
	      }
	
	      data = _queryString2['default'].stringify(data);
	
	      var options = {
	        headers: {
	          'Content-Type': 'application/x-www-form-urlencoded',
	          'Authorization': 'Bearer ' + accessToken
	        }
	      };
	
	      return this.$http.post('' + _jsonConfigOauthJson2['default'].baseUrl + _jsonConfigOauthJson2['default'].revokePath, data, options).then(function (response) {
	        return response;
	      });
	    }
	  }, {
	    key: 'logout',
	    value: function logout() {
	      var _this2 = this;
	
	      var accessToken = this.OAuthToken.getAccessToken();
	      return this.OAuth.revokeToken().then(function (response) {
	        return response;
	      }).then(function (response) {
	        return _this2.revokeAccessToken(accessToken).then(function (response) {
	          _this2.authenticated = _this2.OAuth.isAuthenticated();
	          return response;
	        });
	      })['catch'](function (error) {
	        return error;
	      });
	    }
	  }, {
	    key: 'getAccessToken',
	    value: function getAccessToken() {
	      return this.OAuthToken.getAccessToken();
	    }
	  }]);
	
	  return AuthService;
	})();
	
	exports['default'] = AuthService;
	module.exports = exports['default'];

/***/ },
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _loaderComponent = __webpack_require__(179);
	
	var _loaderComponent2 = _interopRequireDefault(_loaderComponent);
	
	var loaderModule = _angular2['default'].module('loader', []).component('loader', _loaderComponent2['default']).name;
	
	exports['default'] = loaderModule;
	module.exports = exports['default'];

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _loaderHtml = __webpack_require__(180);
	
	var _loaderHtml2 = _interopRequireDefault(_loaderHtml);
	
	var _loaderController = __webpack_require__(181);
	
	var _loaderController2 = _interopRequireDefault(_loaderController);
	
	var loaderComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _loaderHtml2['default'],
	  controller: _loaderController2['default'],
	  controllerAs: 'vm'
	};
	
	exports['default'] = loaderComponent;
	module.exports = exports['default'];

/***/ },
/* 180 */
/***/ function(module, exports) {

	module.exports = "<div class=\"loader\"></div>\n"

/***/ },
/* 181 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var LoaderController = function LoaderController() {
	    'ngInject';
	
	    _classCallCheck(this, LoaderController);
	
	    this.name = 'loader';
	};
	
	exports['default'] = LoaderController;
	module.exports = exports['default'];

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _homeHome = __webpack_require__(183);
	
	var _homeHome2 = _interopRequireDefault(_homeHome);
	
	var _authAuth = __webpack_require__(187);
	
	var _authAuth2 = _interopRequireDefault(_authAuth);
	
	var componentModule = _angular2['default'].module('app.components', [_homeHome2['default'], _authAuth2['default']]).name;
	
	exports['default'] = componentModule;
	module.exports = exports['default'];

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _homeComponent = __webpack_require__(184);
	
	var _homeComponent2 = _interopRequireDefault(_homeComponent);
	
	var _servicesCacheService = __webpack_require__(34);
	
	var _servicesCacheService2 = _interopRequireDefault(_servicesCacheService);
	
	var homeModule = _angular2['default'].module('home', [_angularUiRouter2['default'], _servicesCacheService2['default']]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('home', {
	    url: '/',
	    template: '<home></home>'
	  });
	}]).component('home', _homeComponent2['default']).name;
	
	exports['default'] = homeModule;
	module.exports = exports['default'];

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _homeHtml = __webpack_require__(185);
	
	var _homeHtml2 = _interopRequireDefault(_homeHtml);
	
	var _homeController = __webpack_require__(186);
	
	var _homeController2 = _interopRequireDefault(_homeController);
	
	var homeComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _homeHtml2['default'],
	  controller: _homeController2['default'],
	  controllerAs: 'vm'
	};
	
	exports['default'] = homeComponent;
	module.exports = exports['default'];

/***/ },
/* 185 */
/***/ function(module, exports) {

	module.exports = "<main>\n    <transfers-table></transfers-table>\n</main>\n"

/***/ },
/* 186 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var HomeController = function HomeController(cacheService) {
	  'ngInject';
	
	  _classCallCheck(this, HomeController);
	
	  this.name = 'home';
	
	  this.supplier = cacheService.get('supplier');
	};
	HomeController.$inject = ["cacheService"];
	
	exports['default'] = HomeController;
	module.exports = exports['default'];

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _authComponent = __webpack_require__(188);
	
	var _authComponent2 = _interopRequireDefault(_authComponent);
	
	var _loginLogin = __webpack_require__(191);
	
	var _loginLogin2 = _interopRequireDefault(_loginLogin);
	
	var authModule = _angular2['default'].module('auth', [_angularUiRouter2['default'], _loginLogin2['default']]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	  $stateProvider.state('auth', {
	    url: '/auth',
	    template: '<auth></auth>'
	  });
	}]).component('auth', _authComponent2['default']).name;
	
	exports['default'] = authModule;
	module.exports = exports['default'];

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _authHtml = __webpack_require__(189);
	
	var _authHtml2 = _interopRequireDefault(_authHtml);
	
	var _authController = __webpack_require__(190);
	
	var _authController2 = _interopRequireDefault(_authController);
	
	var authComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _authHtml2['default'],
	  controller: _authController2['default'],
	  controllerAs: 'vm'
	};
	
	exports['default'] = authComponent;
	module.exports = exports['default'];

/***/ },
/* 189 */
/***/ function(module, exports) {

	module.exports = "<div class=\"auth\">\n    <div ui-view></div>\n</div>\n"

/***/ },
/* 190 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var AuthController = function AuthController() {
	  _classCallCheck(this, AuthController);
	
	  this.name = 'auth';
	  console.log('auth');
	};
	
	exports['default'] = AuthController;
	module.exports = exports['default'];

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _loginComponent = __webpack_require__(192);
	
	var _loginComponent2 = _interopRequireDefault(_loginComponent);
	
	var _apiSuppliersService = __webpack_require__(195);
	
	var _apiSuppliersService2 = _interopRequireDefault(_apiSuppliersService);
	
	var _servicesSharedService = __webpack_require__(17);
	
	var _servicesSharedService2 = _interopRequireDefault(_servicesSharedService);
	
	var _servicesCacheService = __webpack_require__(34);
	
	var _servicesCacheService2 = _interopRequireDefault(_servicesCacheService);
	
	var loginModule = _angular2['default'].module('login', [_angularUiRouter2['default'], _apiSuppliersService2['default'], _servicesSharedService2['default'], _servicesCacheService2['default']]).config(["$stateProvider", function ($stateProvider) {
	    "ngInject";
	    $stateProvider.state('auth.login', {
	        url: '/login',
	        template: '<login></login>'
	    });
	}]).component('login', _loginComponent2['default']).name;
	
	exports['default'] = loginModule;
	module.exports = exports['default'];

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _loginHtml = __webpack_require__(193);
	
	var _loginHtml2 = _interopRequireDefault(_loginHtml);
	
	var _loginController = __webpack_require__(194);
	
	var _loginController2 = _interopRequireDefault(_loginController);
	
	var loginComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _loginHtml2['default'],
	  controller: _loginController2['default'],
	  controllerAs: 'vm'
	};
	
	exports['default'] = loginComponent;
	module.exports = exports['default'];

/***/ },
/* 193 */
/***/ function(module, exports) {

	module.exports = "<div class=\"login\">\n    <form class=\"form-signin\" role=\"form\" autocomplete=\"off\" novalidate ng-submit=\"vm.login()\">\n        <h2 class=\"form-signin-heading\">{{ 'login_title' | translate}}</h2>\n        <uib-alert ng-if=\"vm.error\" type=\"danger\" dismiss-on-timeout=\"5000\">{{ 'login_error' | translate}}</uib-alert>\n        <input class=\"form-control\" placeholder=\"{{ 'login_placeholder_email' | translate}}\" required=\"\" autofocus=\"\" type=\"email\" ng-model=\"vm.email\">\n        <input class=\"form-control\" placeholder=\"{{ 'login_placeholder_pass' | translate}}\" required=\"\" type=\"password\" ng-model=\"vm.password\">\n        <button class=\"btn-st btn-st-success btn-lg btn-block\" ng-class=\"{'disabled': vm.loader.visible}\" type=\"submit\">{{ 'login_button' | translate}}</button>\n    </form>\n</div>\n"

/***/ },
/* 194 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var LoginController = (function () {
	    LoginController.$inject = ["$state", "authService", "apiSuppliersService", "sharedService", "cacheService"];
	    function LoginController($state, authService, apiSuppliersService, sharedService, cacheService) {
	        'ngInject';
	
	        _classCallCheck(this, LoginController);
	
	        this.$state = $state;
	        this.authService = authService;
	        this.apiSuppliersService = apiSuppliersService;
	        this.loader = sharedService.loader;
	        this.cacheService = cacheService;
	
	        // TODO: use translations from $translate service
	
	        // Reset login data to defaults
	        this.error = false;
	        this.cacheService['delete']('supplier');
	    }
	
	    _createClass(LoginController, [{
	        key: 'login',
	        value: function login() {
	            var _this = this;
	
	            //TODO Use arrow function chaining promises
	            //authenticate and set the auth header
	            var self = this;
	
	            //Avoid massive requests
	            if (this.loader.visible) {
	                return;
	            }
	            this.loader.visible = true;
	            this.authService.login(this.email, this.password).then(function (response) {
	                return _this.apiSuppliersService.me.get().$promise.then(function (response) {
	                    return response;
	                });
	            }).then(function (response) {
	                _this.cacheService.set('supplier', response);
	                _this.$state.go('home');
	            })['catch'](function (error) {
	                //TODO manage the error with new relic
	                _this.error = true;
	                _this.authService.logout();
	            })['finally'](function () {
	                _this.loader.visible = false;
	            });
	        }
	    }]);
	
	    return LoginController;
	})();
	
	exports['default'] = LoginController;
	module.exports = exports['default'];

/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularResource = __webpack_require__(32);
	
	var _angularResource2 = _interopRequireDefault(_angularResource);
	
	var _jsonConfigApiSuppliersJson = __webpack_require__(29);
	
	var _jsonConfigApiSuppliersJson2 = _interopRequireDefault(_jsonConfigApiSuppliersJson);
	
	var ApiSuppliersService = function ApiSuppliersService($resource) {
	    'ngInject';
	
	    _classCallCheck(this, ApiSuppliersService);
	
	    this.me = $resource(_jsonConfigApiSuppliersJson2['default'].baseUrl + _jsonConfigApiSuppliersJson2['default'].endpoint.me, {}, {
	        get: { method: "GET" }
	    });
	};
	ApiSuppliersService.$inject = ["$resource"];
	
	var apiSuppliersModule = _angular2['default'].module('api.suppliers.suppliers', [_angularResource2['default']]).service('apiSuppliersService', ApiSuppliersService).name;
	
	exports['default'] = apiSuppliersModule;
	module.exports = exports['default'];

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _appHtml = __webpack_require__(197);
	
	var _appHtml2 = _interopRequireDefault(_appHtml);
	
	var _appController = __webpack_require__(198);
	
	var _appController2 = _interopRequireDefault(_appController);
	
	__webpack_require__(199);
	
	var appComponent = {
	  template: _appHtml2['default'],
	  controller: _appController2['default'],
	  restrict: 'E'
	};
	
	exports['default'] = appComponent;
	module.exports = exports['default'];

/***/ },
/* 197 */
/***/ function(module, exports) {

	module.exports = "<!-- Place all UI elements intended to be present across all routes in this file -->\n<div class=\"p-sticky__body app\">\n  <div class=\"p-sticky__content\">\n    <navbar></navbar>\n    <div ui-view class=\"st-container-fluid\"></div>\n  </div>\n  <footer class=\"o-footer\">\n  </footer>\n</div>\n"

/***/ },
/* 198 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var AppController = function AppController() {
	  'ngInject';
	
	  _classCallCheck(this, AppController);
	
	  this.name = 'home';
	};
	
	exports['default'] = AppController;
	module.exports = exports['default'];

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(200);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(212)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/less-loader/index.js!./app.less", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/less-loader/index.js!./app.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(201)();
	// imports
	exports.i(__webpack_require__(202), "");
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ },
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	//TODO:: LOAD VIA WEBPACK
	'use strict';
	
	__webpack_require__(214);
	module.exports = 'offClick';

/***/ }
]);


// WEBPACK FOOTER //
// app.bundle.js